import { inject, observer } from "mobx-react";
import { useAbTestComponent } from "@utils";

import Default from "./Default";

const abTests = {
    dev_1635_20_01_2026: () => import("./AB_1635"),
};

const ListItemAccordion = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default, matchValue: "v2" });

        return <Specified {...props} />;
    }),
);

export default ListItemAccordion;
